// src/components/ui/PageBanner.jsx
// Usage: <PageBanner title="About CSH" crumbs={['Home', 'About CSH']} />

export default function PageBanner({ title, crumbs = [] }) {
  return (
    <div className="page-banner">
      <h1>{title}</h1>
      <div className="breadcrumb">
        {crumbs.map((crumb, i) => (
          <span key={i}>
            {i > 0 && ' > '}
            {crumb}
          </span>
        ))}
      </div>
    </div>
  );
}
